module.exports = __webpack_public_path__ + "1_0_57/img/arrow-select.cedb03c9.svg";